import React from 'react';
import { Box } from '@wix/design-system';
import { BlurControl } from './BlurControl';
import { OpacityControl } from './OpacityControl';
import { useCombinedValueControls } from '../hooks/useCombinedValueControls';
import { ControlService } from '../../types';

type ShadowControlsProps = {
  service: ControlService;
  styleIds: string[];
};

export const ShadowControls: React.FC<ShadowControlsProps> = ({
  styleIds,
  service,
}) => {
  const controlTools = useCombinedValueControls({
    styleIds,
    combinedControlTypes: ['ShadowOpacity', 'ShadowBlur'],
    service,
  });
  return (
    <Box direction="vertical">
      <BlurControl {...controlTools.ShadowBlur} />
      <OpacityControl {...controlTools.ShadowOpacity} />
    </Box>
  );
};
